export default __webpack_public_path__ + "static/media/poster-pitch.5b6994ef.png";